import React, { useEffect, useRef, useState, } from "react";
import { Box } from "@mui/system"
import { useLocation } from "react-router-dom";
import { callApi } from "../../common/api";
import Loader from "./Loader";
import './style/login.css'
import { Typography } from "@mui/material";
import { createDeviceToken } from "../../common/FirebaseCall";

const MyDiv = () => {
  const [RecaptchaVerified, setRecaptchaVerified] = useState(false);
  const [otpPanel, setOtpPanel] = useState(true);
  const [mobile, setMobile] = useState();
  const [email, setEmail] = useState("");
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const [activeInput, setActiveInput] = useState(0)
  const [snackBarMsg, setSnackBarMsg] = useState({
    message: "",
    severity: "success",
    open: false,
  });

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const paramName = queryParams.get("token")
 
  const handleClickOtp = async () => {
    try {

      if (paramName) {
        localStorage.clear()
      } else {
        let data = localStorage.getItem("AllData");
        if (data == 'undefined' || data == null) {
          localStorage.clear()
          window.location.href = `${process.env.REACT_APP_LANDING_PAGE_URL}/login?logout=true&type=investor`
          return;
        } else {
          if(data?.registrationStep > 2){

            window.location.href= "/discover"
            return
          } else {
            window.location.href= "/investorRegister?level=0"
            return
          }
        }
      }

      const otp = otpValues.join("");
      let obj = {
        authId: paramName
      }

      const response = await callApi("post", "auth/authData", obj)
      
      const token = response?.data?.response?.data?.token?.token
      const userData = response?.data?.response?.data?.userData
    
      localStorage.setItem("accessToken", JSON.stringify(paramName))
      localStorage.setItem("token", JSON.stringify(token))
      localStorage.setItem("AllData", JSON.stringify(userData))
      localStorage.setItem("authenticate", true);

      // const firebaseToken = await createDeviceToken()
      // const object = {
      //       deviceToken:firebaseToken,
      //       type:1
      //     }
      //     if(firebaseToken){
      //       callApi('post','userRegister/userDeviceToken',object).then((response)=>{
      //         console.log(response,"---------------loginResponse")
      //       }).catch((err)=>{
      //       console.log(err)
      //       })
      //     }

      const step = response?.data?.response?.data?.userData?.registrationStep

      if (step === 3) {
        window.location.href = "/discover"
      }
      else if (step === 2) {
        window.location.href = "/investorRegister?level=1"
      }
      else if (step === 1) {
        window.location.href = "/investorRegister?level=0"
      }

      setSnackBarMsg({
        message: response.data.response.message,
        severity: "success",
        open: true,
      });

    } catch (error) {
      if (error.response) {
        // The request was made, but the server responded with an error status
        setSnackBarMsg({
          message: error.response.data.message,
          severity: "error",
          open: true,
        });
        // You can handle specific HTTP error codes here if needed
      } else if (error.request) {
        // The request was made, but no response was received
        setSnackBarMsg({
          message: "An error occurred while processing your request.",
          severity: "error",
          open: true,
        });
      } else {
        // Something happened in setting up the request that triggered an Error
        setSnackBarMsg({
          message: "An error occurred while processing your request.",
          severity: "error",
          open: true,
        });
      }
    }
  }

  React.useEffect(() => {
    handleClickOtp()
  }, [])

  return (
    <>
      <Box>
        <Loader />
      </Box>
      <Box sx={{ justifyContent: "center", alignItems: "center", display: "flex", height: "115vh" }}>
        <Typography style={{ color: "white", fontSize: "20px", zIndex: "1" }}>Please Wait...</Typography>
      </Box>
    </>
  );
};

export default MyDiv;
